import {
  GridView,
  GridViewDataOptions,
  GridViewSortBy,
} from '@data-access/grid-views';
import { cloneDeep } from 'lodash';
import {
  HeaderCellConfiguration,
  WcgTableFilters,
} from '@wcg/frontend-framework';

/**
 * @Check if prop exists in the given object
 * */
export function checkIfPropExists(
  obj: unknown,
  key: string,
): obj is { [key: string]: unknown } {
  return obj instanceof Object && obj && key in obj;
}

function isStringJsonParsable<T extends string>(obj: T): boolean {
  try {
    const parse = JSON.parse(obj);
    return (
      parse !== null &&
      parse !== undefined &&
      (parse instanceof Object || Array.isArray(parse))
    );
  } catch {
    return false;
  }
}

export function getUpdatedViews(
  stateGrids: GridView[],
  currentGrids: GridView[],
) {
  return stateGrids?.length > 0
    ? stateGrids.reduce((acc, arr) => {
        for (const grid of currentGrids) {
          if (grid.id === arr.id) {
            if (grid.name === arr.name) {
              acc.push(arr);
            } else {
              acc.push(grid);
            }
          }
        }
        return acc;
      }, [] as GridView[])
    : [];
}

function mapDataOptions<T extends object>(data: T, key: string) {
  let dataOption: T;

  if (!checkIfPropExists(data, key)) {
    return;
  }
  // eslint-disable-next-line prefer-const
  dataOption = isStringJsonParsable(data[key] as string)
    ? ([...JSON.parse(data[key] as string)] as T)
    : (data[key] as T);
  return dataOption;
}

export function mapCustomViews<T extends object>(data: T): GridViewDataOptions {
  return {
    headers: mapDataOptions(data, 'headers') as HeaderCellConfiguration[],
    sortBy: mapDataOptions(data, 'sortBy') as GridViewSortBy,
    filters: cloneDeep(mapDataOptions(data, 'filters') as WcgTableFilters),
  };
}
